<template>
    <v-app-bar app :elevation="0" :color="barColor" v-if="isMobile">
        <v-app-bar-nav-icon @click.stop="navIconClick" color="secondary" />
        <v-toolbar-title v-if="showTitle">{{ $route.meta.title }}</v-toolbar-title>
    </v-app-bar>
</template>

<script>

export default {
    name: 'app-bar-mobile',
    data: () => ({
        drawer: true,
        miniVariant: false,
    }),
    computed: {
        barColor(){
            return this.$helpers.in_obj( this.$route.meta.appBarMobile, 'bg', 'white' )
        },
        showTitle(){
            return this.$helpers.in_obj( this.$route.meta.appBarMobile, 'title', false )
        }
    },
    methods: {
        navIconClick(){
            this.$emit( 'nav-click' )
        }
    }
}
</script>

<style lang="scss" scoped>

</style>